import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Event } from 'data/event/event.modle';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: Event[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<Event[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const eventSlice = createSlice({
  name: 'event',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default eventSlice;
